import request from '@/utils/request'

// 获取签署主体实名状态
export function getSignerInfo(data) {
  return request({
    url: '/api/common/v1/task/getSignerInfo',
    method: 'post',
    data
  })
}

// 保存签署任务草稿
export function saveDraft(data) {
  return request({
    url: '/api/common/v1/task/saveDraft',
    method: 'post',
    data
  })
}

// 获取合同图片
export function getSignFileImgArrayApi(data) {
  return request({
    url: '/api/common/v1/tool/getSignFileImgArray',
    method: 'post',
    data
  })
}

// 获取任务及签署信息
export function getTaskDetailInfo(data) {
  return request({
    url: '/api/common/v1/task/getTaskDetailInfo',
    method: 'post',
    data
  })
}






// export function contractTemplateImgApi(fileId) {  // 获取合同图片
//   return request({
//     url: '/contractTemplate/getPng?fileId='+fileId+'&nocache='+new Date().getTime(),
//     method: 'get'
//   })
// }


export function templateEditApi(data) {
  return request({
    url: '/contractTemplate/edit',
    method: 'post',
    data
  })
}

export function getSignatoryListApiByTemplateId(templateId) {
  return request({
    url: '/contractTemplate/signatoryList?templateId=' + templateId + '&nocache=' + new Date().getTime(),
    method: 'get'
  })
}

export function setTemplateInitiateApi(data) {
  return request({
    url: '/contractTemplate/initiate',
    method: 'post',
    data
  })
}

export function getTemplatetSignListApi(params) {
  return request({
    url: '/contractTemplate/getContractSignList',
    method: 'get',
    params
  })
}

export function getTemplateInfoApi(templateId) {
  return request({
    url: '/contractTemplate/get?templateId=' + templateId + '&nocache=' + new Date().getTime(),
    method: 'get'
  })
}

export function downloadTemplateApi(templateId) {
  return request({
    url: '/contractTemplate/downloadTemplate?templateId=' + templateId + '&nocache=' + new Date().getTime(),
    method: 'get',
    responseType: 'blob'
  })
}

export function createContractByTemplateApi(data) {
  return request({
    url: 'contractTemplate/createContractByTemplate',
    method: 'post',
    data
  })
}

export function getTemplateList(data) {
  return request({
    url: '/api/common/v1/cusPcTemplate/list',
    method: 'post',
    data
  })
}

export function replaceAfterPreview(data) {
  return request({
    url: '/api/common/v1/cusPcTemplate/replaceAfterPreview',
    method: 'post',
    data
  })
}

// export function queryTemplateParams(data) {
//   return request({
//     url: '/api/common/v1/cusPcTemplate/queryParams',
//     method: 'post',
//     data
//   })
// }

export function queryTemplateParams(data) {
  return request({
    url: '/api/common/v1/cusPcTemplate/getOneTempleByIdWebPc',
    method: 'post',
    data
  })
}

// export function getOneTempleByIdWebPc(data) {
//   return request({
//     url: '/api/common/v1/cusPcTemplate/getOneTempleByIdWebPc',
//     method: 'post',
//     data
//   })
// }


export function saveToBeSent(data) {
  return request({
    url: '/api/common/v1/task/saveToBeSent',
    method: 'post',
    data
  })
}

export function getCurrentUserSignInfo(data) {
  return request({
    url: '/api/common/v1/task/getCurrentUserSignInfo',
    method: 'post',
    data
  })
}


export function getTaskImportTemplate(data) {
  return request({
    url: '/api/common/v1/task/getTaskImportTemplate',
    method: 'post',
    responseType: 'blob',
    data
  })
}

export const importBatchFileAction = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + 'api/common/v1/task/excelTaskParsing'

export function excelTaskParsing(data) {
  return request({
    url: '/api/common/v1/task/excelTaskParsing',
    method: 'post',
    data
  })
}

export function batchSaveDraft(data) {
  return request({
    url: '/api/common/v1/task/batchSaveDraft',
    method: 'post',
    data
  })
}

export function batchSaveToBeSent(data) {
  return request({
    url: '/api/common/v1/task/batchSaveToBeSent',
    method: 'post',
    data
  })
}

// 申请存证接口
export function applyReport(data) {
  return request({
    url: '/api/common/v1/reoprt/applyReport',
    method: 'post',
    data
  })
}

// 下载存证接口
export function downReport(data) {
  return request({
    url: '/api/common/v1/reoprt/downReport',
    method: 'post',
    data,
    responseType: 'blob'
  })
}


